import { PaginatedColumn } from '../types/app';
import {
  InstallationAddressRequest,
  InstallationAddressRequestTouched,
  InstallationRequest,
  InstallationRequestTouched,
} from '../types/installation';
import { JobTypeCategory } from '../types/job';
import { InstallationLogRequest } from '../types/logs';

export const INSTALLATION_TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: 'Fuente',
    key: 'insuranceCompany',
    sorteable: true,
    minWidth: 75,
    maxWidth: 75,
    centered: true,
  },
  {
    label: 'Serie',
    key: 'vin',
    sorteable: true,
    minWidth: 130,
    maxWidth: 130,
  },
  {
    label: 'Asignado',
    key: 'fchAsignado',
    sorteable: true,
    minWidth: 90,
    maxWidth: 90,
    centered: true,
    sortDirection: 'DESC',
  },
  {
    label: 'Proceso',
    key: 'fchEnProceso',
    sorteable: true,
    minWidth: 90,
    maxWidth: 90,
    centered: true,
  },
  {
    label: 'Instalación',
    key: 'fchInstaladoFSM',
    sorteable: true,
    minWidth: 95,
    maxWidth: 95,
    centered: true,
  },
  {
    label: 'Est. Aseg.',
    key: 'estatusInstalacion',
    sorteable: true,
    minWidth: 100,
    maxWidth: 100,
    centered: true,
  },
  {
    label: 'Est. Gor.',
    key: 'gdlStatus',
    sorteable: true,
    minWidth: 100,
    maxWidth: 100,
    centered: true,
  },
  {
    label: 'id Job Fsm',
    key: 'externalId',
    sorteable: true,
    minWidth: 100,
    maxWidth: 100,
    centered: true,
  },
  {
    label: 'Categoría',
    key: 'jobCategory',
    sorteable: true,
    minWidth: 160,
    maxWidth: 160,
  },
  {
    label: 'Cliente',
    key: 'contratante',
    sorteable: true,
    minWidth: 180,
    flex: 1,
  },
  {
    label: '# Intentos',
    key: 'contactAttempts',
    sorteable: true,
    minWidth: 100,
    maxWidth: 100,
    centered: true,
  },
  {
    label: 'Último Contacto',
    key: 'lastContactAttempt',
    sorteable: true,
    minWidth: 140,
    maxWidth: 140,
  },
  {
    label: 'IVR',
    key: 'isIVR',
    sorteable: true,
    minWidth: 60,
    maxWidth: 60,
    centered: true,
  },
  {
    label: 'Últ. Comentario',
    key: 'lastLog',
    sorteable: false,
    minWidth: 150,
    flex: 2,
  },
  {
    label: 'Modificado',
    key: 'lastModifiedBy',
    sorteable: false,
    minWidth: 110,
    centered: true,
    flex: 1,
  },
  {
    label: '',
    key: 'actions',
    sorteable: false,
    minWidth: 100,
    maxWidth: 130,
    centered: true,
  },
];

export enum InstallationProvidetStatus {
  gnp = 'gnp',
  hdi = 'hdi',
}

export enum InstallationOrigin {
  gnp = 'gnp',
  gdl = 'gdl',
  hdi = 'hdi',
}

export const ORIGIN_FILTER_OPTIONS = [
  {
    label: 'Todos',
    id: undefined,
  },
  {
    label: 'GNP',
    id: InstallationOrigin.gnp,
  },
  {
    label: 'Gorila',
    id: InstallationOrigin.gdl,
  },
  {
    label: 'HDI',
    id: InstallationOrigin.hdi,
  },
];

export const IVR_FILTER_OPTIONS = [
  {
    label: 'Todos',
    id: undefined,
  },
  {
    label: 'Particular',
    id: 'true',
  },
  {
    label: 'Pyme',
    id: 'false',
  },
];

export enum InstallationStatusCode {
  ar = 'AR',
  as = 'AS',
  c = 'C',
  ca = 'CA',
  co = 'CO',
  ep = 'EP',
  f = 'F',
  i = 'I',
  nc = 'NC',
  ni = 'NI',
  p = 'P',
  pc = 'PC',
  pe = 'PE',
  pr = 'PR',
  r = 'R',
  sr = 'SR',
  // HDI
  ec = '3', // En CallCenter
  prH = '4', // Programado
  ee = '5', // En ejecución
}

export const GDL_FILTER_OPTIONS = [
  {
    label: 'Todos',
    id: undefined,
  },
  {
    label: 'Prospección',
    id: InstallationStatusCode.ep,
  },
  {
    label: 'Asignación Requerida',
    id: InstallationStatusCode.ar,
  },
  {
    label: 'Prospección Rechazada',
    id: InstallationStatusCode.pr,
  },
  {
    label: 'Por concretar',
    id: InstallationStatusCode.pc,
  },
  {
    label: 'Concretado',
    id: InstallationStatusCode.c,
  },
  {
    label: 'Sin respuesta',
    id: InstallationStatusCode.sr,
  },
  {
    label: 'Rechazado',
    id: InstallationStatusCode.r,
  },
  {
    label: 'Checkout',
    id: InstallationStatusCode.co,
  },
  {
    label: 'Pendiente',
    id: InstallationStatusCode.pe,
  },
  {
    label: 'Inicio',
    id: InstallationStatusCode.i,
  },
  {
    label: 'En progreso',
    id: InstallationStatusCode.p,
  },
  {
    label: 'Finalizado',
    id: InstallationStatusCode.f,
  },
  {
    label: 'Cancelado',
    id: InstallationStatusCode.ca,
  },
];

export const MIN_WIDTH_MAP = '400px';
export const MIN_HEIGHT_MAP = '220px';
export const DATA_WIDTH = '280px';
export const DATA_XL_WIDTH = '560px';

export const ADDRESS_INSTALLATION_DEFAULTS: InstallationAddressRequest = {
  georeference: '',
};

export const NEW_INSTALLATION_DEFAULTS: InstallationRequest = {
  engineNumber: '',
  policyNumber: '',
  vin: '',
  licensePlate: '',
  client: {
    clientName: '',
    rfc: '',
    name: '',
    lastName: '',
    motherName: '',
    phone: '',
    email: '',
  },
  label: '',
  georeference: '',
  category: JobTypeCategory.installation,
};

export const ADDRESS_INSTALLATION_TOUCHED_DEFAULTS: InstallationAddressRequestTouched = {
  georeferenceTouched: false,
  latitudeTouched: false,
  longitudeTouched: false,
};

export const NEW_INSTALLATION_TOUCHED_DEFAULTS: InstallationRequestTouched = {
  brandTouched: false,
  subBrandTouched: false,
  modelTouched: false,
  engineNumberTouched: false,
  policyNumberTouched: false,
  vinTouched: false,
  licensePlateTouched: false,
  clientTouched: {
    rfcTouched: false,
    nameTouched: false,
    lastNameTouched: false,
    phoneTouched: false,
    emailTouched: false,
    clientNameTouched: false,
  },
  insuranceCompanyTouched: false,
  georeferenceTouched: false,
  latitudeTouched: false,
  longitudeTouched: false,
  categoryTouched: false,
  labelTouched: false,
};

export const MINIMAL_MODEL_YEAR = 1886;

export const NEW_LOG_DEFAULTS: InstallationLogRequest = {
  logType: undefined,
  comment: undefined,
  logSubType: undefined,
};

// Valid states to generate a job appointment
export const INSTALLATION_STATES_VALID: string[] = [
  // GNP / Gorila
  InstallationStatusCode.ep, // En proceso
  InstallationStatusCode.nc, // No contactado
  InstallationStatusCode.ni, // No instalado
  // HDI
  InstallationStatusCode.ec, // En CallCenter
  InstallationStatusCode.prH, // Programado
  InstallationStatusCode.ee, // En ejecución
];
